<script setup lang="ts">
import { timezones } from '@app/utils/constants/timezones'

import { useTzDisplay } from '@hooks/auth/use-tz-display.hook'

import { TzSelect } from '@UI/Fields/TzSelect'

defineOptions({
  name: 'TzDisplay',
})

const {
  refValue,
  setTimezone,
} = useTzDisplay()
</script>

<template>
  <TzSelect
    :key="refValue"
    :value="refValue"
    :timezones="timezones"
    @option:selected="setTimezone"
  />
</template>
